// The component's own popup: a full-height modal with the calendar scrolling inside it.
// For pages that have no modal of their own (or want to drop theirs).

import popupCss from './popup.css?raw';
import { mountCalendar } from './calendar';
import { lockScroll, unlockScroll } from './scroll-lock';

let overlay = null;
let mountEl = null;
let calendar = null;
let mountedWith = '';
let isOpen = false;

function ensurePopup() {
  if (overlay) return;
  const host = document.createElement('div');
  host.setAttribute('data-dmc-live-schedule-popup', '');
  document.body.appendChild(host);
  const root = host.attachShadow({ mode: 'open' });
  root.innerHTML =
    `<style>${popupCss}</style>` +
    '<div class="popup-overlay" aria-hidden="true">' +
    '<div class="popup-body" role="dialog" aria-modal="true" aria-label="Live online classes weekly schedule">' +
    '<button type="button" class="popup-close" aria-label="Close schedule">' +
    '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" aria-hidden="true"><path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>' +
    '</button>' +
    '<div class="popup-header"><h2 class="popup-title">Live Online Classes</h2></div>' +
    '<div class="popup-mount"></div>' +
    '</div></div>';
  overlay = root.querySelector('.popup-overlay');
  mountEl = root.querySelector('.popup-mount');
  overlay.addEventListener('click', (e) => {
    if (e.target === overlay) closePopup();
  });
  root.querySelector('.popup-close').addEventListener('click', closePopup);
}

export function openPopup(opts) {
  ensurePopup();
  // One popup per page; a different set of options (another button) re-mounts it.
  const key = JSON.stringify(opts);
  if (calendar && key !== mountedWith) {
    calendar.destroy();
    calendar = null;
  }
  if (!calendar) {
    calendar = mountCalendar(mountEl, {
      ...opts,
      scroll: 'self',
      stickyTop: 0,
    });
    mountedWith = key;
  }
  if (isOpen) return;
  isOpen = true;
  lockScroll();
  overlay.classList.add('is-open');
  overlay.setAttribute('aria-hidden', 'false');
}

export function closePopup() {
  if (!isOpen) return false;
  isOpen = false;
  overlay.classList.remove('is-open');
  overlay.setAttribute('aria-hidden', 'true');
  unlockScroll();
  return true;
}
